import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, from, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoginDialogComponent } from '../components/login-dialog/login-dialog.component';
import { SessionTokenService } from './session-token.service';
import { RegisterDialogComponent } from '../components/register-dialog/register-dialog.component';
type LoginResponse = { token: string };

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private dialog = inject(DialogService);
  private tokens = inject(SessionTokenService);

  login(email: string, password: string): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${environment.apiUrl}auth/login`, {
        email,
        password,
      })
      .pipe(tap((res) => this.tokens.setToken(res.token)));
  }

  register(
    email: string,
    password: string,
    firstName: string,
    lastName: string
  ): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${environment.apiUrl}auth/register`, {
        email,
        password,
        firstName,
        lastName,
      })
      .pipe(tap((res) => this.tokens.setToken(res.token)));
  }

  openLoginDialog$(email?: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const ref = this.dialog.open(LoginDialogComponent, {
        header: 'Zaloguj się',
        width: '420px',
        modal: true,
        closable: true,
        data: { email },
      });

      ref.onClose.subscribe((result) => {
        if (result === true || result === 'success') {
          observer.next(true);
          observer.complete();
          return;
        }

        if (typeof result === 'string' && result.startsWith('register:')) {
          const email = result.split(':')[1];
          this.openRegisterDialog$(email).subscribe((v) => {
            observer.next(v);
            observer.complete();
          });
          return;
        }

        observer.next(false);
        observer.complete();
      });
    });
  }

  openRegisterDialog$(email?: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const ref = this.dialog.open(RegisterDialogComponent, {
        header: 'Zarejestruj się',
        width: '420px',
        modal: true,
        closable: true,
        data: { email },
      });

      ref.onClose.subscribe((result) => {
        if (result === true || result === 'success') {
          observer.next(true);
          observer.complete();
          return;
        }

        if (typeof result === 'string' && result.startsWith('login:')) {
          const email = result.split(':')[1];
          this.openLoginDialog$(email).subscribe((v) => {
            observer.next(v);
            observer.complete();
          });
          return;
        }

        observer.next(false);
        observer.complete();
      });
    });
  }
}
